import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function queryCageDetails(id, cage) {
  // Format Query
  const query = `query queryCageDetails(
        $id: ID, $cage: String
      ) { queryCageDetails(id: $id, cage: $cage)  {  organization,supplierCaps, contractHistory }}`;

  // Variables
  const variables = { id, cage };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function queryNiinDetails(id, niin) {
  // Format Query
  const query = `query queryNiinDetails(
        $id: ID, $niin: String
      ) { queryNiinDetails(id: $id, niin: $niin)  {  itemDetails, toolingRecords, stockOnHand, niinContractHistory, drawingDetails, pnDetails,techCharacteristics, itemDescription, packagingInfo, WSDC, ebsPackaging  }}`;

  // Variables
  const variables = { id, niin };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}


export async function queryToolingComments(cage, partNum, niin) {
  // Format Query
  const query = `query queryToolingComments(
    $cage: String, $partNum: String, $niin: String
      ) { queryToolingComments(cage: $cage, partNum: $partNum, niin: $niin)  
        { 
          toolingCommentsGovList{
            
            itemId,
            commentTs,
            email,
            comment
            
          }
        } 
      }`;

  // Variables
  const variables = { cage, partNum, niin };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function mutationToolingComment(cage, partNum, email, comment, niin) {
  // Format Query
  const query = `mutation mutationToolingComment(
    $cage: String, $partNum: String, $email: String, $comment: String, $niin: String
    ) { mutationToolingComment(cage: $cage, partNum: $partNum, email: $email, comment: $comment, niin: $niin)
      {status}
    }`;

  // Variables
  const variables = { cage, partNum, email, comment, niin };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}


// WEBPACK FOOTER //
// ./src/pages/universalDetails/graphql.js